// extracted by mini-css-extract-plugin
export default {"trainers":"TrainerList_trainers__d0S5C"};